import { render } from "./BalCloseIcon.vue?vue&type=template&id=4b9e3786"
const script = {}
script.render = render

export default script